<template>
  <div class="tbp">
    <div class="base">
      <div class="row">
        <div class="title">抬头类型</div>
        <div class="srk">
          <template v-for="item in radioValue">
            <input
              type="radio"
              name="nameType"
              v-model.trim="titleType"
              class="check_box tui-checkbox"
              @change="changetitleType"
              :value="item.type"
            /><span>{{ item.name }}</span>
          </template>
        </div>
      </div>
      <div class="row">
        <div class="title"><span>*</span>发票抬头</div>
        <div class="srk">
          <input
            type="text"
            v-model.trim="form.companyName"
            placeholder="请输入抬头名称"
            maxlength="100"
          />
          <span class="other-btn" @click="selectInvoiceTitle(true)">
            其他
          </span>
        </div>
      </div>
      <template v-if="titleType == 'company'">
        <div class="row">
          <div class="title">纳税人识别号</div>
          <div class="srk">
            <input
              type="text"
              v-model.trim="form.taxId"
              placeholder="请输入纳税人识别号"
              maxlength="22"
            />
          </div>
        </div>
      </template>

      <template v-if="titleType == 'company'">
        <div class="row">
          <div class="title">注册地址</div>
          <div class="srk">
            <input type="text" v-model="form.address" placeholder="请输入注册地址" maxlength="64" />
          </div>
        </div>
      </template>
      <template v-if="titleType == 'company'">
        <div class="row">
          <div class="title">注册电话</div>
          <div class="srk">
            <input type="text" v-model="form.phone" placeholder="请输入注册电话" maxlength="50" />
          </div>
        </div>
      </template>
      <template v-if="titleType == 'company'">
        <div class="row">
          <div class="title">开户银行</div>
          <div class="srk">
            <input
              type="text"
              v-model="form.accountName"
              placeholder="请输入开户银行"
              maxlength="50"
            />
          </div>
        </div>
      </template>
      <template v-if="titleType == 'company'">
        <div class="row">
          <div class="title">银行账号</div>
          <div class="srk">
            <input
              type="text"
              v-model="form.accountNo"
              placeholder="请输入银行账号"
              maxlength="50"
            />
          </div>
        </div>
      </template>

      <template>
        <div class="row">
          <div class="title"><span>*</span>接收邮箱</div>
          <div class="srk">
            <input
              type="text"
              v-model.trim="form.receiveEmail"
              placeholder="请输入接收邮箱"
              maxlength="50"
            />
          </div>
        </div>
      </template>

      <!-- 目前后端代码不支持填写备注，待后端代码完善后打开 -->
      <!-- <div class="row">
        <div class="title">更多内容</div>
        <div class="srk">
          <input type="text" placeholder="填写备注、地址等（非必填）">
        </div>
      </div> -->
    </div>
    <div class="total">
      <div class="title">总金额</div>
      <div class="totalInfo">
        <div>{{ baseInfo.totalPrice }}元</div>
        <div>共{{ baseInfo.orderCount }}张</div>
      </div>
    </div>
    <!-- 目前后端代码不支持发邮件，待后端代码完善后打开 -->
    <!-- <div class="receive">接收方式</div>
    <div class="email">
      <div class="row">
        <div class="title">电子邮箱</div>
        <div class="srk">
          <input type="email" maxlength="50">
        </div>
      </div>
    </div> -->
    <div class="bottom">
      <div :class="[canSubmit ? 'continue' : 'uncontinue']" @click="makeInvoice">提交</div>
    </div>
    <div class="mask" :class="{ maskShow: tipShow }">
      <div class="dialog">
        <div class="title">提示</div>
        <div class="content">按照税务政策要求，即日起天坛公园官方购票平台电子发票变更为数电发票。开发票所需时间由1个工作日调整为1-3个工作日，由此带来的不便，敬请谅解。</div>
        <div class="btn-container">
          <div class="btn close" @click="closeClick">取消</div>
          <div class="btn confirm" @click="confirmClick">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { applyInvoice, InvoiceReApply } from "@/service/invoice/apply.js";
import { getInvoiceTitleList } from "@/service/invoiceTitle/api.js";
export default {
  name: "wirteInvoiceName",
  data() {
    return {
      tipShow: false,
      baseInfo: {},
      radioValue: [
        {
          type: "company",
          name: "企业单位"
        },
        {
          type: "person",
          name: "个人/非企业单位"
        }
      ],
      form: {
        companyName: "",
        taxId: "",
        address: "",
        phone: "",
        accountName: "",
        accountNo: "",
        receiveEmail: ""
      },
      titleType: "",
      state: true,
      selectedInvoiceTitle: {},
      loadingFlag: false
    };
  },
  created() {
    this.loadingFlag = false
    this.baseInfo = JSON.parse(window.sessionStorage.getItem("baseInfo"));
    //  团体只能开团体订单，不能开散客订单begin
    // if(this.baseInfo.orderType == "GROUP"){
    //   let newRadioValue = this.radioValue
    //   newRadioValue = newRadioValue.filter((item)=>{
    //     return item.type == 'company'
    //   })
    //   this.radioValue = newRadioValue
    // }
    // 团体只能开团体订单，不能开散客订单end
    if (window.sessionStorage.getItem("selectedInvoiceTitle")) {
      this.selectedInvoiceTitle = JSON.parse(window.sessionStorage.getItem("selectedInvoiceTitle"));
      console.log(this.selectedInvoiceTitle);
    } else {
      this.getDefaultTitle();
      return;
    }
    if (this.selectedInvoiceTitle.type != undefined) {
      if (this.selectedInvoiceTitle.type == "person") {
        this.titleType = "person";
      } else {
        this.titleType = "company";
      }
      if (Object.keys(this.selectedInvoiceTitle).length) {
        this.form.companyName = this.selectedInvoiceTitle.companyName;
        this.form.taxId = this.selectedInvoiceTitle.taxId;

        this.form.address = this.selectedInvoiceTitle.address;
        this.form.phone = this.selectedInvoiceTitle.phone;
        this.form.accountName = this.selectedInvoiceTitle.accountName;
        this.form.accountNo = this.selectedInvoiceTitle.accountNo;
      }
    } else {
      this.titleType = "company";
      if (Object.keys(this.selectedInvoiceTitle).length) {
        this.form.companyName = this.selectedInvoiceTitle.companyName;
        this.form.taxId = this.selectedInvoiceTitle.taxId;

        this.form.address = this.selectedInvoiceTitle.address;
        this.form.phone = this.selectedInvoiceTitle.phone;
        this.form.accountName = this.selectedInvoiceTitle.accountName;
        this.form.accountNo = this.selectedInvoiceTitle.accountNo;
      }
    }
  },
  computed: {
    canSubmit: function() {
      if (this.titleType == "company" && this.form.companyName != "") {
        return true;
      } else if (this.titleType == "person" && this.form.companyName != "") {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    closeClick() {
      this.loadingFlag = false;
      this.tipShow = false;
    },
    async getDefaultTitle() {
      const userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
      const parameter = {
        userId: userInfo.userId
      };
      const { data } = await getInvoiceTitleList.call(this, parameter);
      const defaultTitle = data.filter(item => {
        return item.isDefault == "1";
      });
      console.log(defaultTitle);
      // 没有默认抬头
      if (defaultTitle.length == 0) {
        this.titleType = "person";
        this.form.companyName = "个人";
        return;
      }
      if (this.baseInfo.orderType == "GROUP" && defaultTitle[0].type == "person") {
        this.titleType = "company";
        this.form.companyName = "";
        this.form.taxId = defaultTitle[0].taxId;
      }
      if (this.baseInfo.orderType == "GROUP" && defaultTitle[0].type == "company") {
        this.titleType = "company";
        this.form.companyName = defaultTitle[0].companyName;
        this.form.taxId = defaultTitle[0].taxId;

        this.form.address = defaultTitle[0].address;
        this.form.phone = defaultTitle[0].phone;
        this.form.accountName = defaultTitle[0].accountName;
        this.form.accountNo = defaultTitle[0].accountNo;
      }
      if (this.baseInfo.orderType != "GROUP") {
        if (defaultTitle[0].type == "company") {
          this.titleType = "company";
          this.form.companyName = defaultTitle[0].companyName;
          this.form.taxId = defaultTitle[0].taxId;

          this.form.address = defaultTitle[0].address;
          this.form.phone = defaultTitle[0].phone;
          this.form.accountName = defaultTitle[0].accountName;
          this.form.accountNo = defaultTitle[0].accountNo;
        } else {
          this.titleType = "person";
          this.form.companyName = "个人";
          this.form.taxId = defaultTitle[0].taxId;
        }
      }
      // if(this.baseInfo.orderType == "GROUP" && defaultTitle[0].taxId==""){
      //   return
      // }else{
      //   if(defaultTitle[0].taxId) {
      //     this.titleType = 'company'
      //     this.form.companyName = defaultTitle[0].companyName
      //     this.form.taxId = defaultTitle[0].taxId
      //   }else{
      //     this.titleType = 'person'
      //     this.form.companyName = defaultTitle[0].companyName
      //     this.form.taxId = defaultTitle[0].taxId
      //   }
      // }
    },
    changetitleType() {
      this.loadingFlag = false
      if (this.titleType == "person") {
        this.form = {
          companyName: "个人",
          taxId: "",
          isDefault: 1,
          address: "",
          phone: "",
          accountName: "",
          accountNo: "",
          receiveEmail: ""
        };
      } else {
        this.form = {
          companyName: "",
          taxId: "",
          isDefault: 1,
          address: "",
          phone: "",
          accountName: "",
          accountNo: "",
          receiveEmail: ""
        };
      }
    },
    selectInvoiceTitle(isSelect) {
      this.$router.push({ path: "/invoiceTitleList", query: { isSelect, isAlign: false } });
    },
    checkParams() {
      console.log(this.form);
      if (!this.state) {
        this.$toast(`请勿重复点击`);
        return false;
      }
      // if (this.form.companyName != "") {
      //   // 公司正则
      //   const regu = /^[a-zA-Z0-9\.\s·•\,\(\)\（\）\u4e00-\u9fff]{2,50}$/;
      //   const companyCheck = new RegExp(regu);
      //   if (!companyCheck.test(this.form.companyName)) {
      //     this.$toast(`请填写正确公司名称`);
      //     return false;
      //   }
      // }
      if (this.titleType == "company" && this.form.taxId != "") {
        // 税号正则
        const regu = /^[0-9A-Z]{6,20}$/;
        const taxIdCheck = new RegExp(regu);
        if (!taxIdCheck.test(this.form.taxId)) {
          this.$toast(`请填写正确税号`);
          return false;
        }
      }
      // 注册地址
      if (this.form.address != "") {
        const addressregu = /^[a-zA-Z0-9-\.\s·•\,\(\)\（\）\u4e00-\u9fff]{2,50}$/;
        const addressCheck = new RegExp(addressregu);
        if (!addressCheck.test(this.form.address)) {
          this.$toast(`请填写正确注册地址`);
          return false;
        }
      }
      console.log(this.form.phone);
      // 手机号校验
      if (this.form.phone != "") {
        const phoneregu = /^((0\d{2,3}-\d{7,8})|(1[3-9][0-9]{9}))$/;
        const phoneCheck = new RegExp(phoneregu);
        if (!phoneCheck.test(this.form.phone)) {
          this.$toast(`注册电话格式不正确`);
          return false;
        }
      }

      // 开户银行
      if (this.form.accountName != "") {
        const accountNameregu = /^[a-zA-Z0-9\.\s·•\,\(\)\（\）\u4e00-\u9fff]{2,50}$/;
        const accountNameCheck = new RegExp(accountNameregu);
        if (!accountNameCheck.test(this.form.accountName)) {
          this.$toast(`开户银行格式不正确`);
          return false;
        }
      }
      // 银行卡号校验
      if (this.form.accountNo != "") {
        const accountNoregu = /^[0-9]{1,30}$/;
        const accountNoCheck = new RegExp(accountNoregu);
        if (!accountNoCheck.test(this.form.accountNo)) {
          this.$toast(`银行卡号格式不正确`);
          return false;
        }
      }
      // 邮箱校验
      if (this.form.receiveEmail == "") {
        this.$toast(`请输入邮箱`);
        return false;
      }
      if (this.form.receiveEmail != "") {
        const emailregu = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
        const emailCheck = new RegExp(emailregu);
        if (!emailCheck.test(this.form.receiveEmail)) {
          this.$toast(`邮箱格式不正确`);
          return false;
        }
      }
      return true;
    },
    makeInvoice() {
      if (this.loadingFlag) {
        this.$toast("请勿重复操作");
        return;
      }
      this.loadingFlag = true;
      // if (this.titleType === "person" && this.form.companyName == "") return;
      // if (this.titleType === "company" && this.form.companyName == "") return;
      const flag = this.checkParams();
      if (!flag) {
        this.loadingFlag = false;
        return;
      }
      this.tipShow = true;
      // console.log(this.selectedInvoiceTitle)
      // return
    },
    async confirmClick() {
      if (this.titleType == "person") {
        Object.keys(this.form).forEach(item => {
          if (!this.form[item]) delete this.form[item];
        });
      }
      console.log(this.titleType)
      console.log(this.form)
      if (
        Object.keys(this.selectedInvoiceTitle).length &&
        this.selectedInvoiceTitle.detailList != undefined
      ) {
        //  console.log('重开')
        // return
        const parameter = {
          id: this.selectedInvoiceTitle.id,
          userId: JSON.parse(window.localStorage.getItem("userInfo")).userId,
          orderType: JSON.parse(window.sessionStorage.getItem("baseInfo")).orderType,
          invoiceType: "3",
          applyChannel: "weixin",
          invoiceHeader: this.titleType,
          companyName: this.form.companyName,
          taxId: this.form.taxId,
          receiveEmail: this.form.receiveEmail.toLowerCase(),
          address: this.form.address,
          phone: this.form.phone,
          accountName: this.form.accountName,
          accountNo: this.form.accountNo
        };
        // alert(JSON.stringify(parameter))
        // return;
        this.state = false;
        const result = await InvoiceReApply.call(this, parameter);
        if (result.status == 0) {
          this.$toast("已提交，请耐心等待");
          this.loadingFlag = false;
          this.tipShow = false;
          this.$router.push(`/myinvoice`);
        } else {
          this.$toast(result.errorMessage);
          this.loadingFlag = false;
          this.tipShow = false;
        }
        this.state = true;
      } else {
        // console.log('新开')
        const parameter = {
          userId: JSON.parse(window.localStorage.getItem("userInfo")).userId,
          orderType: JSON.parse(window.sessionStorage.getItem("baseInfo")).orderType,
          invoiceType: "3",
          applyChannel: "weixin",
          invoiceHeader: this.titleType,
          companyName: this.form.companyName,
          taxId: this.form.taxId,
          orderIdList: JSON.parse(window.sessionStorage.getItem("InvoiceOrderList")),
          receiveEmail: this.form.receiveEmail.toLowerCase(),
          address: this.form.address,
          phone: this.form.phone,
          accountName: this.form.accountName,
          accountNo: this.form.accountNo
        };
        // alert(JSON.stringify(parameter))
        // return;
        this.state = false;
        const result = await applyInvoice.call(this, parameter);
        if (result.status == 0) {
          this.$toast("已提交，请耐心等待");
          this.loadingFlag = false;
          this.tipShow = false;
          this.$router.push(`/myinvoice`);
        } else {
          this.loadingFlag = false;
          this.tipShow = false;
          this.$toast(result.errorMessage);
        }
        this.state = true;
      }
    }
  }
};
</script>

<style scoped lang="less">
.mask {
  position: fixed;
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.42);
  z-index: 9;
  display: none;
}
.maskShow {
  display: block;
}
.dialog {
  width: 80%;
  background-color: #fff;
  border-radius: 16px;
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .title {
    width: 100%;
    text-align: center;
    color: #000;
    font-size: 0.45rem;
    margin: 8px 0;
  }
  .content {
    text-align: center;
    font-size: 0.4rem;
    line-height: 0.6rem;
    padding: 0.2rem;
  }
  .btn-container {
    display: flex;
    align-items: center;
    margin-top: auto;
    .btn {
      width: 50%;
      height: 1.2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.4rem;
    }
    .close {
      background-color: #999;
    }
    .confirm {
      background-color: #3b6d9c;
      color: #fff;
    }
  }
}
.tbp {
  padding-bottom: 1.6rem + 0.346667rem;
  min-height: 100vh;
  overflow-y: hidden;
}
.base {
  background: #ffffff;
  padding: 0.266667rem;
  margin: (0.533333rem / 2);
  border-radius: 0.266667rem;
}
.row {
  display: flex;
  justify-content: space-between;
  padding: 0.2rem 0;
  color: #000;
  font-size: 0.4rem;
  flex: 1;
  .title {
    width: 3.733333rem;
    line-height: 0.56rem;
    span {
      font-size: 0.373333rem;
      color: red;
    }
  }
  .srk {
    width: 100%;
    display: flex;
    span {
      color: #999999;
      display: inline-block;
      padding: 0 0.133333rem;
      margin-top: 0.04rem;
    }
    input[type="text"] {
      display: block;
      width: 100%;
      line-height: 0.56rem;
    }
    .other-btn {
      display: inline-block;
      margin-top: 0.066667rem;
      // width: 1.333333rem;
      width: 1.333333rem;
      font-size: 0.32rem;
      text-align: center;
      padding: 0.133333rem;
      background: #3b6d9c;
      color: #fff;
      border-radius: 0.133333rem;
    }
  }
}
.total {
  background: #ffffff;
  padding: 0.466667rem 0.266667rem;
  margin: (0.533333rem / 2);
  border-radius: 0.266667rem;
  display: flex;
  justify-content: space-between;
  .totalInfo {
    display: flex;
    justify-content: space-between;
    margin-top: 0.04rem;
    align-items: center;
    width: 100%;
    font-size: 0.373333rem;
    color: #999999;
  }
}
.title {
  width: 3.733333rem;
  line-height: 0.56rem;
  color: #000;
  font-size: 0.4rem;
}
.receive {
  font-size: 0.373333rem;
  color: #999;
  margin: 0.533333rem 0.266667rem 0.133333rem 0.266667rem;
}
.email {
  background: #ffffff;
  padding: 0.266667rem;
  margin: (0.533333rem / 2);
  border-radius: 0.266667rem;
}
.bottom {
  height: 1.6rem + 0.346667rem;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  background: rgb(248, 248, 248);
  .continue {
    position: fixed;
    margin: auto;
    width: 98%;
    bottom: 0.266667rem;
    left: 0;
    right: 0;
    background: #3b6d9c;
    line-height: 1.2rem;
    border-radius: 1.333333rem;
    text-align: center;
    color: #ffffff;
    font-size: 0.48rem;
  }
  .uncontinue {
    position: fixed;
    margin: auto;
    width: 98%;
    bottom: 0.266667rem;
    left: 0;
    right: 0;
    background: #999999;
    line-height: 1.2rem;
    border-radius: 1.333333rem;
    text-align: center;
    color: #ffffff;
    font-size: 0.48rem;
  }
}
.tui-checkbox {
  width: 0.533333rem;
  height: 0.5rem;
  background-color: #ffffff;
  border: solid 1px #dddddd;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  font-size: 0.8rem;
  margin: 0;
  padding: 0;
  position: relative;
  display: inline-block;
  vertical-align: top;
  cursor: default;
  -webkit-appearance: none;
  -webkit-user-select: none;
  user-select: none;
  -webkit-transition: background-color ease 0.6s;
  transition: background-color ease 0.6s;
}
.tui-checkbox:checked {
  background: #db4239;
  border: solid 1px #db4239;
}
.tui-checkbox:checked::after {
  content: "";
  top: 0.1rem;
  left: 0.09rem;
  position: absolute;
  background: transparent;
  border: #fff solid 2px;
  border-top: none;
  border-right: none;
  height: 0.12rem;
  width: 0.25rem;
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
</style>
